import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-main-banner',
  templateUrl: './home-main-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./home-main-banner.component.scss']
})
export class HomeMainBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
